import { createAction, props, Action } from '@ngrx/store';
import { Parameter } from '@models';
import { errorTypes } from '@parameter/store/parameter.reducer';

export const create = createAction(
  '[Parameter Component] create',
  props<{row: Parameter}>()
);

export const getCollection = createAction('[Parameter Component] getCollection');

export const collectionLoaded = createAction(
  '[Parameter Component] collectionLoaded',
  props<{newCollection: Parameter[]}>()
);

export const failRequest = createAction(
  '[Parameter Component] failRequest',
  props<{error: any, errorType: errorTypes}>()
);

export const resetParams = createAction(
  '[Parameter Component] reset params',
  props<{row: Parameter}>()
);
